<template>
  <div>
    <v-app-bar
      flat
      :color="
        updateButtonController.status == 'running' ? 'amber lighten-3' : 'white'
      "
      class="x-scroll"
    >
      <div class="pa-2">
        <v-btn class="gray font-weight-bold" @click="onBack"
          ><v-icon left>mdi-arrow-left-circle</v-icon>戻る</v-btn
        >
      </div>
      <div class="pa-2">
        <v-btn
          :class="'font-weight-bold ' + updateButtonController.color"
          :disabled="updateButtonController.disabled"
          @click="onUpdateButton"
          ><v-icon left>{{ updateButtonController.icon }}</v-icon
          >{{ updateButtonController.label }}</v-btn
        >
      </div>
      <div class="pa-2">
        <v-btn
          class="info font-weight-bold"
          dense
          @click="onSubmit"
          :disabled="updateButtonController.saveDisabled"
          ><v-icon left>mdi-content-save</v-icon>保存</v-btn
        >
      </div>
      <div class="pa-2">
        <v-btn
          class="info font-weight-bold"
          dense
          @click="onSetting"
          :disabled="updateButtonController.saveDisabled"
          ><v-icon left>mdi-cog</v-icon>設定</v-btn
        >
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
import { ref, reactive, toRefs, defineComponent } from "@vue/composition-api";
import store from "@/store/index.js";

export default defineComponent({
  components: {},
  setup(props, ctx) {
    const state = reactive({
      updateButtonController: {
        disabled: false,
        status: "stopping",
        label: "自動更新を開始",
        icon: "mdi-timer-outline",
        color: "info",
        saveDisabled: false,
      },
    });

    // app-barにあるコンポーネント呼び出し
    const action = (params) => {
      switch (params.func) {
        case "editmode_set":
          if (params.mode == "new") {
            state.updateButtonController.disabled = true;
          } else {
            state.updateButtonController.disabled = false;
          }
          break;
        case "auto_set":
          if (params.mode) {
            state.updateButtonController.label = "自動更新ON(停止する)";
            state.updateButtonController.status = "running";
            state.updateButtonController.icon = "mdi-timer-off-outline";
            state.updateButtonController.color = "error";
            state.updateButtonController.saveDisabled = true;
          } else {
            state.updateButtonController.label = "自動更新を開始";
            state.updateButtonController.status = "stopping";
            state.updateButtonController.icon = "mdi-timer-outline";
            state.updateButtonController.color = "info";
            state.updateButtonController.saveDisabled = false;
          }
      }
    };

    const onSubmit = async () => {
      ctx.emit("save");
    };
    const onSetting = async () => {
      ctx.emit("setting");
    };
    const onUpdateButton = async () => {
      ctx.emit("update", state.updateButtonController.status);
    };
    const onBack = async () => {
      ctx.emit("on_back");
    };

    return {
      ...toRefs(state),
      action,
      onSubmit,
      onSetting,
      onUpdateButton,
      onBack,
    };
  },
});
</script>
